<template>
  <div class="custom-slider-wrapper">
    <div class="slider-track" :style="trackStyle">
      <div
        v-for="n in max - min + 1"
        :key="n"
        :class="segmentClass(n + min - 1)"
        :style="segmentStyle(n + min - 1)"
        @click="onSegmentClick(n + min - 1)"
      >
        <span v-if="breakpoints.includes(n + min - 1)" class="breakpoint-dot"></span>
      </div>
      <div class="slider-thumb" :style="thumbStyle" @mousedown="startDrag" @touchstart="startDrag">
        <span class="thumb-label">{{ value }}m</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomSlider',
  props: {
    min: { type: Number, default: 1 },
    max: { type: Number, default: 50 },
    step: { type: Number, default: 1 },
    value: {
      type: Number,
      default() {
        return this.max || 50
      }
    }, // Start from max value
    breakpoints: { type: Array, default: () => [] },
    disabledRanges: { type: Array, default: () => [] }, // [{ from: 1, to: 9 }, { from: 21, to: 50 }]
    activeColor: { type: String, default: '#3b82f6' },
    disabledColor: { type: String, default: '#e5e7eb' },
    breakpointColor: { type: String, default: '#f59e0b' }
  },
  data() {
    return {
      dragging: false
      //   value: this.max // Start from max value
    }
  },
  computed: {
    trackStyle() {
      return {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        height: '32px',
        width: '100%',
        userSelect: 'none'
      }
    },
    thumbStyle() {
      // ((this.max - this.value) / (this.max - this.min)) * 100
      const percent = ((this.value - this.min) / (this.max - this.min)) * 100
      //   console.log('Thumb percent:', percent, this.value)
      return {
        position: 'absolute',
        left: `calc(${percent}% - 16px)`,
        top: '0',
        zIndex: 2
      }
    }
  },
  methods: {
    segmentClass(val) {
      if (this.isDisabled(val)) return 'slider-segment disabled'
      if (this.breakpoints.includes(val)) return 'slider-segment breakpoint'
      return 'slider-segment active'
    },
    segmentStyle(val) {
      let color = this.activeColor
      if (this.isDisabled(val)) color = this.disabledColor
      if (this.breakpoints.includes(val)) color = this.breakpointColor
      return {
        background: color,
        flex: `1 1 0%`,
        height: '8px',
        borderRadius: '4px',
        margin: '0 1px',
        cursor: this.isDisabled(val) ? 'not-allowed' : 'pointer',
        position: 'relative'
      }
    },
    isDisabled(val) {
      return this.disabledRanges.some((range) => val >= range.from && val <= range.to)
    },
    onSegmentClick(val) {
      if (!this.isDisabled(val)) {
        this.$emit('input', val)
      }
    },
    startDrag(e) {
      if (this.isDisabled(this.value)) return
      this.dragging = true
      document.addEventListener('mousemove', this.onDrag)
      document.addEventListener('mouseup', this.stopDrag)
      document.addEventListener('touchmove', this.onDrag)
      document.addEventListener('touchend', this.stopDrag)
    },
    onDrag(e) {
      if (!this.dragging) return
      const slider = this.$el.querySelector('.slider-track')
      const rect = slider.getBoundingClientRect()
      const clientX = e.touches ? e.touches[0].clientX : e.clientX
      let percent = (clientX - rect.left) / rect.width
      percent = Math.max(0, Math.min(1, percent))
      let val = Math.round(this.min + percent * (this.max - this.min))
      val = Math.round(val / this.step) * this.step
      // Clamp to allowed range
      if (this.isDisabled(val)) return
      this.$emit('input', val)
    },
    stopDrag() {
      this.dragging = false
      document.removeEventListener('mousemove', this.onDrag)
      document.removeEventListener('mouseup', this.stopDrag)
      document.removeEventListener('touchmove', this.onDrag)
      document.removeEventListener('touchend', this.stopDrag)
    }
  }
}
</script>

<style scoped>
.custom-slider-wrapper {
  width: 100%;
  padding: 12px 0;
}
.slider-track {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  height: 32px;
}
.slider-segment {
  transition: background 0.2s;
}
.slider-segment.active {
  background: #3b82f6;
}
.slider-segment.disabled {
  background: #e5e7eb;
}
.slider-segment.breakpoint {
  background: #f59e0b;
  position: relative;
}
.breakpoint-dot {
  position: absolute;
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 10px;
  height: 10px;
  background: #f59e0b;
  border-radius: 50%;
  border: 2px solid #fff;
}
.slider-thumb {
  width: 32px;
  height: 32px;
  background: #fff;
  border: 2px solid #3b82f6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  cursor: grab;
  z-index: 2;
}
.thumb-label {
  font-size: 12px;
  color: #3b82f6;
  font-weight: bold;
}
</style>
